import { render, staticRenderFns } from "./ProductEditVariantGroup.vue?vue&type=template&id=66218b83&scoped=true&"
import script from "./ProductEditVariantGroup.vue?vue&type=script&lang=js&"
export * from "./ProductEditVariantGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditVariantGroup.vue?vue&type=style&index=0&id=66218b83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66218b83",
  null
  
)

export default component.exports